import { QUOTES } from 'sites/routes'
import preserveMarketingParams from 'utils/DOM/preserveMarketingParams'

export interface RedirectParams {
  period?: string
}
function redirectQuotes({ period = '' }: RedirectParams) {
  const url =
    QUOTES + '?' + [period && `period=${period}`, 'similar'].filter(Boolean).join('&')

  // PPI-1770: the query is rebuilt here, so merge rather than append.
  document.location.assign(preserveMarketingParams(url))
}

export default redirectQuotes
